enum ACTIONS {
    FETCH_MODULES = 'FETCH_MODULES',
    CREATE_MODULE = 'CREATE_MODULE',
    PATCH_MODULE = 'PATCH_MODULE'
}

export default ACTIONS;